export default (): Record<string, unknown> => ({
  "Content-Type": "application/json;charset=UTF-8",
});
